import * as React from "react";
import { Column } from "primereact/column";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import PageLayout from "../../components/PageLayout";
import useEntitiesList from "../../utils/listHookNew";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { renderHeader } from "../../components/TableUtils"
import { DataTable } from "primereact/datatable";
import Can from "../../auth/Can";
import roles from "../../auth/roles";
import { deleteService } from "../../api/service";

export default function ProductServicesListsList({ opt, activeTenant }) {

    const [result, loading, setLoading, globalFilter, setGlobalFilter, forceRefresh] = useEntitiesList("modellitagliando", "", `tenant_id='${activeTenant._id}'`, "");

    const [openModal, setOpenModal] = React.useState(false);
    const toggle = () => setOpenModal(!openModal);

    const onDelete = async id => {
        const value = await deleteService(id);
        toggle();
        forceRefresh();
        return value;
    };

    const modalSection = () => (
        <Modal zIndex={2000} centered size="sm" isOpen={openModal ? true : false} backdrop={true}>
            <ModalHeader toggle={toggle}>
                Eliminazione Modello Tagliando
        </ModalHeader>
            <ModalBody>
                <p>Confermi di voler eliminare il Modello Tagliando?</p>
            </ModalBody>
            <ModalFooter>
                <Button color="link" className="btn-link-dark" onClick={toggle}>Annulla</Button>{' '}
                <Button color="danger" className="ml-auto" onClick={() => onDelete(openModal._id)}>Elimina</Button>
            </ModalFooter>
        </Modal>
    );

    const getHeader = () => {
        return (
            <Can
                roles={[roles.SERVICE, roles.ADMIN]}
                yes={() =>
                    <div className="action-container">
                        <Link
                            title="Aggiungi modello"
                            className="btn btn-primary p-button-icon-only"
                            to={`services-add`}
                        >
                            <FontAwesomeIcon icon="wrench" className="mr-1" />Nuovo Modello
                        </Link>
                    </div>
                }
                no={() => null}
            />
        );
    };

    const onRefresh = () => {
        forceRefresh();
        setGlobalFilter("");
    }

    const exportTable = () => {
        dtable.exportCSV();
    }

    return (
        <PageLayout title={`Elenco Modelli Tagliando - Dealer: ${activeTenant.name}`}>
            <Row>
                <Col>
                    <DataTable
                        loading={loading}
                        value={result}
                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                        className="p-datatable-hoverable-rows p-datatable-customers"
                        responsive
                        paginator={true}
                        autoLayout={false}
                        first={0}
                        rows={20}
                        totalRecords={result.length}
                        paginatorPosition="both"
                        header={renderHeader(loading, result.length, undefined, getHeader(), { globalFilter, setGlobalFilter, onRefresh }, exportTable)}
                        globalFilter={globalFilter}
                        emptyMessage={() => (<div className="text-center">Nessun modello in tabella</div>)}
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        currentPageReportTemplate="Visualizzati {first} di {last} Modelli su un totale di {totalRecords}"
                    >
                        <Column
                            field="attributes.description"
                            header="Descrizione"
                            sortable
                            filter
                            style={{ wordWrap: "break-word" }}
                            body={(rowData, column) => {
                                return (
                                    <Link
                                        to={`/tenant/services-view/${rowData._id}`}
                                    >
                                        {rowData.attributes.description}
                                    </Link>
                                );
                            }}
                        />
                        <Column
                            field="attributes.km"
                            header="Scadenza km"
                            sortable
                            filter
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.duration"
                            header="Scadenza mesi"
                            sortable
                            filter
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.model"
                            header="Marca"
                            sortable
                            filter
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.supplier"
                            header="Modello"
                            sortable
                            filter
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.preparation"
                            header="Allestimento"
                            sortable
                            filter
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.supplier"
                            header="Alimentazione"
                            sortable
                            filter
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.notes"
                            header="Note"
                            sortable
                            filter
                            style={{ wordWrap: "break-word" }}
                        />

                        <Column
                            field="actions"
                            body={(rowData, column) => {
                                return (
                                    <div className="action-container">
                                        <Can
                                            roles={[roles.ADMIN, roles.DEALER, roles.SERVICE]}
                                            yes={() =>
                                                <Link
                                                    title="Gestisci modello"
                                                    className="btn btn-sm btn-primary p-button-icon-only"
                                                    to={`/tenant/services/${rowData._id}`}
                                                >
                                                    <FontAwesomeIcon icon="pencil-alt" />
                                                </Link>
                                            }
                                            no={() => (<Link
                                                title="Visualizza modello"
                                                className="btn btn-sm btn-primary p-button-icon-only"
                                                to={`/tenant/services-view/${rowData._id}`}
                                            >
                                                <FontAwesomeIcon icon="eye" />
                                            </Link>)}
                                        />
                                        <Can
                                            roles={[roles.ADMIN]}
                                            yes={() =>
                                                <Button
                                                    color="danger"
                                                    title="Elimina modello"
                                                    onClick={() => setOpenModal(rowData)}
                                                    className="btn-sm p-button-icon-only"
                                                >
                                                    <FontAwesomeIcon icon="trash-alt" />
                                                </Button>
                                            }
                                        />
                                    </div>
                                );
                            }}
                            style={{ wordWrap: "break-word" }}
                        />
                    </DataTable>
                </Col>
            </Row>
            {modalSection()}
        </PageLayout>
    );
}
